__turbopack_context__.v({
  "listing-heading": "ListingHeading-module-scss-module__zSW3cq__listing-heading",
});
